import React from "react";
import { Box } from "@mui/material";

export interface AppLayoutProps {
  sidebar: React.ReactNode;
  mainContent: React.ReactNode;
  navBar: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  sidebar,
  mainContent,
  navBar,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#F5F5F5",
      }}
    >
      {sidebar}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
        }}
      >
        <Box sx={{ minHeight: { xs: "44px", sm: "48px" } }}>{navBar}</Box>
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            padding: { xs: "10px", sm: "14px" },
          }}
        >
          {mainContent}
        </Box>
      </Box>
    </Box>
  );
};
